/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async filter_signatories(page) {
    let data = { page: page };
    let response = await apiCall("config/signatory/list/all", data);
    return response;
  },

  async get_active_signatories() {
    let data = { page: 1 };
    let response = await apiCall("config/signatory/list/active", data);
    return response;
  },

  async create_signatory(first_name, last_name, designation) {
    let data = {
      first_name: first_name,
      last_name: last_name,
      designation: designation,
    };
    let response = await apiCall("config/signatory/create", data);
    return response;
  },

  async update_signatory(signatory_id, first_name, last_name, designation, status) {
    let data = {
      first_name: first_name,
      last_name: last_name,
      designation: designation,
      signatory_id: signatory_id,
      status: status,
    };
    let response = await apiCall("config/signatory/update", data);
    return response;
  },

  async update_signatory_status(signatory_id, status) {
    let data = {
      status: status,
      signatory_id: signatory_id,
    };
    let response = await apiCall("config/signatory/update/status", data);
    return response;
  },

  async deleteSignatory(signatory_id) {
    let data = { signatory_id: signatory_id };
    let response = await apiCall("config/signatory/delete", data);
    return response;
  },

  async count_signatories() {
    let data = { requester: "admin" };
    let response = await apiCall("config/signatory/list/count", data);
    return response;
  },

  async filter_roles(data) {
    let response = await apiCall("config/role/list/all", data);
    return response;
  },

  async fetchClientProfile() {
    let response = await apiCall("client/info", []);
    return response;
  },

  async updateClientProfile(data) {
    let response = await apiCall("client/update", data);
    return response;
  },

  async configureNewRole(data) {
    let response = await apiCall("user/role/new_role", data);
    return response;
  },

  async updateUserRole(data) {
    let response = await apiCall("user/role/update_role", data);
    return response;
  },

  async fetchUsers() {
    let response = await apiCall("user/user/list_users", []);
    return response;
  },
  async inviteUser(data) {
    let response = await apiCall("user/user/invite_user", data);
    return response;
  },

  async deleteUser(data) {
    let response = await apiCall("user/user/remove_user", data);
    return response;
  },

  async fetchSpecialAccounts() {
    let response = await apiCall("configuration/specialaccount/list", []);
    return response;
  },

  async setSpecialAccount(configId, accountId) {
    const data = {
      "id":configId,
      "account_id":accountId
    }
    let response = await apiCall("config/specialaccount/set", data);
    return response;
  },
  
  async fetchGateways() {
    let response = await apiCall("school/collectors/schoolcollector/list_collectors", []);
    return response;
  },

  async updateGateway(data) {
    let response = await apiCall("school/collectors/schoolcollector/update_collector", data);
    return response;
  },
  
  async fetchCompanyTypes() {
    let response = await apiCall("central/companytype/list", []);
    return response;
  },

  async configureCompanyType(typeId) {
    const data = {
      "company_type_id": typeId
    }
    let response = await apiCall("central/rental/reconfigure_company_type", data);
    return response;
  },

  async uploadLogo(data) {
    let response = await apiCall("user/clientprofile/upload_logo", data);
    return response;
  },

  async fetchSignatories(){
    let response = await apiCall("configuration/signatory/list_signatories", []);
    return response;
  },

  async createSignatory(data){
    let response = await apiCall("configuration/signatory/add_signatory", data);
    return response;
  },

  async fetchPreferences() {
    let response = await apiCall("configuration/preference/get_all_preferences", []);
    return response;
  },

  async updatePreference(preferenceId, preferenceValue) {
    const data = {
      "id":preferenceId,
      "preference_value":preferenceValue
    }
    let response = await apiCall("configuration/preference/update_preference", data);
    return response;
  },

  async fetchBackupList() {
    let response = await apiCall("platform/webclient/backup_list", []);
    return response;
  },

  async resetProfile(data) {
    let response = await apiCall("platform/webclient/reset_profile", data);
    return response;
  },

  async restoreBackup(backupId) {
    let response = await apiCall("platform/webclient/restore_profile", { backup_id: backupId });
    return response;
  },
  async fetchKeys() {
    return await apiCall("user/apikey/list_keys", []);
  },
   async createKey(data) {
    return await apiCall("user/apikey/new_key", data);
  },

};
